import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import PassportDetails from './PassportDetails';
import VisaInstructions from './VisaInstructions';
import VisaStatus from './VisaStatus';
import PreembarkationForm from './PreembarkationForm';
import PermissionSplash from 'components/PermissionSplash';

export default class Travel extends React.Component {
	render() {
		let routeProps = this.props;
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'TravelRequirements' && role.access_read === "1")
		}) : false
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Switch>
					<Route path="/portal/travel/Passport Details" render={() => <PassportDetails {...routeProps} />} />
					<Route path="/portal/travel/Visa Instructions and Documents" render={() => <VisaInstructions {...routeProps} />} />
					<Route path="/portal/travel/Visa Status" render={() => <VisaStatus {...routeProps} />} />
					<Route path="/portal/travel/Visa Pre-Embarkation Form" render={() => <PreembarkationForm {...routeProps} />} />
					<Route path="*" render={() => (
						<Redirect to="/portal/travel/Passport Details" />
					)} />
				</Switch>
			);
		} else {
			return (

				<PermissionSplash />

			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Travel/index.jsx